import { useLocation } from "react-router-dom";
import SEO from "./SEO";
import SEOConfig, { publisherRef } from "./SEOConfig";

const DriversSEO = ({ drivers = [] }) => {
  const location = useLocation();
  const { siteUrl } = SEOConfig;
  const fullUrl = `${siteUrl}${location.pathname}`;

  const title = "Пілоти ліги: профілі та статистика";
  const description =
    "Пілоти української симрейсинг ліги Slick Racing Ukraine. Кар'єра, новини, останні результати та детальна статистика пілотів.";

  // Add relevant keywords for the drivers page
  const keywords = [
    "Slick Racing Ukraine пілоти",
    "симрейсинг гонщики",
    "сімрейсінг гонщики",
    "віртуальний автоспорт",
    "iRacing пілоти",
    "українські симрейсери",
    "гоночна команда",
    "статистика пілотів",
    "симрейсери",
    "сімрейсери",
  ];

  // Define breadcrumbs for better navigation and SEO
  const breadcrumbs = [
    {
      name: "Головна",
      url: siteUrl,
    },
    {
      name: "Пілоти",
      url: fullUrl,
    },
  ];

  // Only drivers with a slug have a canonical profile URL to point at.
  const listed = drivers.filter((driver) => driver.seoUrl);

  const schema = {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    name: title,
    description: description,
    url: fullUrl,
    inLanguage: "uk",
    publisher: publisherRef,
  };
  if (listed.length > 0) {
    schema.mainEntity = {
      "@type": "ItemList",
      name: "Пілоти Slick Racing Ukraine",
      numberOfItems: listed.length,
      itemListElement: listed.map((driver, index) => ({
        "@type": "ListItem",
        position: index + 1,
        name: `${driver.firstName} ${driver.lastName}`,
        url: `${siteUrl}/drivers/${driver.id}/${driver.seoUrl}`,
      })),
    };
  }

  return (
    <SEO
      title={title}
      description={description}
      keywords={keywords}
      url={fullUrl}
      schema={schema}
      canonical={fullUrl}
      type="website"
      breadcrumbs={breadcrumbs}
      lang="uk"
    />
  );
};

export default DriversSEO;
